import { render, staticRenderFns } from "./Coi.vue?vue&type=template&id=42b52bfc"
import script from "./Coi.vue?vue&type=script&lang=js"
export * from "./Coi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports